type ToastKind = 'success' | 'error'

/**
 * Minimal toast notification — appends a styled element to <body> and removes
 * it after a short delay. Replaces the legacy jQuery notifications module.
 */
export function showNotification(message: string, kind: ToastKind = 'success'): void {
  if (typeof document === 'undefined') return

  const el = document.createElement('div')
  el.className = `toast toast-${kind}`
  el.setAttribute('role', 'status')
  el.textContent = message
  document.body.appendChild(el)

  el.style.transition = 'opacity 0.3s ease'
  window.setTimeout(() => {
    el.style.opacity = '0'
    window.setTimeout(() => el.remove(), 300)
  }, 2600)
}

export default showNotification
